const cx = (...c: (string | false | null | undefined)[]) => c.filter(Boolean).join(' ')

const TableHeader: React.FC = () => (
  <div className="grid grid-cols-[60px,1fr,60px] md:grid-cols-[80px,1fr,80px] px-3 py-2 text-xs font-medium text-gray-500">
    <div>Rank</div>
    <div>User</div>
    <div className="text-right">Points</div>
  </div>
)

const Row: React.FC<{ r: { username?: string | null; mana: number; rank: number }; isMe?: boolean }> = ({ r, isMe }) => (
  <div className={cx('grid grid-cols-[60px,1fr,60px] md:grid-cols-[80px,1fr,80px] items-center px-3 py-2 border-t', isMe && 'bg-amber-50')}>
    <div className="font-semibold">#{r.rank}</div>
    <div className="truncate">
      <div className="font-medium truncate">{r.username}</div>
    </div>
    <div className="text-right font-semibold">{parseInt(r.mana.toString()).toLocaleString()}</div>
  </div>
)

const Board: React.FC<{ meId?: string; rows: Array<{ username?: string | null; mana: number; rank: number }> }> = ({ meId, rows }) => (
  <div className="rounded-2xl border overflow-hidden bg-white">
    <TableHeader />
    <div className="divide-y">
      {rows.map((r) => (
        <Row key={`${r.username}`} r={r} isMe={meId === r.username} />
      ))}
    </div>
  </div>
)

export default Board
